<template>
	<div class="col-12 p-0 login-box">
		<div class="col-10 col-md-5 col-lg-4 pl-0 pr-0 ml-auto mr-auto login-ilus bg-white rounded-top-1 justify-content-center d-none d-md-flex">
			<img class="w-100" src="/assets/login/header-login.png">
			<img class="img-fluid" src="/assets/login/ilustrasi-login.svg">
		</div>
		<div class="col-10 col-md-5 col-lg-4 pl-0 pr-0 pb-2 ml-auto mr-auto login-content cus-box-shadow bg-white rounded-bot-1 rounded-top-sm-1 cus-box-sm-none" v-show="showOTP == false && showPin == false">
			<div class="col-12 font-weight-bold font-size-13 text-center color-black pt-4 pb-3">Login</div>
			<form role="form" v-on:submit.prevent="onLogin">
				<div class="col-12 pl-5 pr-5 pb-2">
					<ml-alert v-for="alert in alerts" :key="alert.id" :type="alert.type" :message="alert.message" @close="removeAlert(alert.id)" close/>
					<div class="input-div one" :class="user == true ? 'focus' : ''">
						<div class="i">
							<i class="fas fa-user icon"></i>
						</div>
						<div class="div">
							<h5>Kode Mobile Counter</h5>
							<input type="text" class="input" @focus="userClick" @blur="userBlur" v-model="username">
						</div>
					</div>
					<div class="mt-n3 color-red font-size-10" v-if="fieldErrors.username">Username {{ fieldErrors.username }} </div>
					<div class="input-div pass" :class="pass == true ? 'focus' : ''">
						<div class="i">
							<i class="fas fa-lock icon"></i>
						</div>
						<div class="div">
							<h5>Kata Sandi</h5>
							<input type="password" class="input" @focus="passClick" @blur="passBlur" v-model="password" id="in-password">
						</div>
						<span @click="showPassword" class="icon-password" :class="pass == true ? 'color-mila' : 'color-gray-2'">
							<span v-show="sPassword"><i class="far fa-eye"></i></span>
							<span v-show="!sPassword"><i class="far fa-eye-slash"></i></span>
						</span>
					</div>
					<div class="mt-2 color-red font-size-10" v-if="fieldErrors.password">Password {{ fieldErrors.password }} </div>
				</div>
				<div class="col-12 pt-4 pb-4 text-center">
					<button class="col-6 btn bg-template btn-login box-purple" type="submit">
						<div class="text-capitalize color-white font-weight-bold font-size-11" :disabled="isAttempting"><i class="fas fa-sign-in-alt mr-3"></i>{{ isAttempting ? 'Proses...' : 'Masuk'}}</div>
					</button>
				</div>
			</form>
		</div>
		<div class="col-10 col-md-5 col-lg-4 pl-0 pr-0 pb-2 ml-auto mr-auto login-content cus-box-shadow bg-white rounded-bot-1 rounded-top-sm-1 cus-box-sm-none" v-show="showOTP">
			<div class="col-12 font-weight-bold font-size-13 text-center color-black pt-4 pb-3">Login</div>
			<form role="form" v-on:submit.prevent="onOtp">
				<div class="col-12 pl-5 pr-5 pb-2">
					<ml-alert v-for="alert in alerts" :key="alert.id" :type="alert.type" :message="alert.message" @close="removeAlert(alert.id)" close/>
					<div class="input-div pass" :class="pass == true ? 'focus' : ''">
						<div class="i">
							<i class="fas fa-lock icon"></i>
						</div>
						<div class="div">
							<h5>Masukan Kode OTP yang sudah dikirim ke No WhatsApp anda</h5>
							<input type="text" class="input" v-model="otpCode">
						</div>
					</div>
					<div class="mt-2 color-red font-size-10" v-if="fieldErrors.otp_code">OTP {{ fieldErrors.otp_code }} </div>
				</div>
				<div class="col-12 pt-4 pb-4 text-center">
					<button class="col-6 btn bg-template btn-login box-purple" type="submit">
						<div class="text-capitalize color-white font-weight-bold font-size-11" :disabled="isAttempting"><i class="fas fa-sign-in-alt mr-3"></i>{{ isAttempting ? 'Proses...' : 'Masuk'}}</div>
					</button>
				</div>
			</form>
		</div>
		<div class="col-10 col-md-5 col-lg-4 pl-0 pr-0 pb-2 ml-auto mr-auto login-content cus-box-shadow bg-white rounded-bot-1 rounded-top-sm-1 cus-box-sm-none" v-show="showPin">
			<div class="col-12 font-weight-bold font-size-13 text-center color-black pt-4 pb-3">Login</div>
			<form role="form" v-on:submit.prevent="onPin">
				<div class="col-12 pl-5 pr-5 pb-2">
					<ml-alert v-for="alert in alerts" :key="alert.id" :type="alert.type" :message="alert.message" @close="removeAlert(alert.id)" close/>
					<div class="input-div pass" :class="pass == true ? 'focus' : ''">
						<div class="i">
							<i class="fas fa-lock icon"></i>
						</div>
						<div class="div">
							<h5>Masukan PIN</h5>
							<input type="text" class="input" v-model="pinCode">
						</div>
					</div>
					<div class="mt-2 color-red font-size-10" v-if="fieldErrors.pin_code">PIN {{ fieldErrors.pin_code }} </div>
				</div>
				<div class="col-12 pt-4 pb-4 text-center">
					<button class="col-6 btn bg-template btn-login box-purple" type="submit">
						<div class="text-capitalize color-white font-weight-bold font-size-11" :disabled="isAttempting"><i class="fas fa-sign-in-alt mr-3"></i>{{ isAttempting ? 'Proses...' : 'Masuk'}}</div>
					</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
	data() {
		return {
			username: '',
			password: '',
			otpCode: '',
			user: false,
			pass: false,
			sPassword: true,
			showOTP: false,
			showPin: false,
			pinCode: '',
		};
	},
	computed: {
		...mapState('auth', ['isAttempting', 'fieldErrors', 'alerts', 'userData']),
	},
	methods: {
		...mapMutations('auth', ['removeAlert', 'reset']),
		...mapActions('auth', ['login', 'loginOtp', 'loginPin']),

		onLogin() {
			this.login({ username: this.username, password: this.password }).then((res) => {
				if(res.otp == true) {
					this.showOTP = true
				} else if (res.pin == true) {
					this.showPin = true
				} else {
					this.redirect()
				}
			});
		},
		onOtp() {
			this.loginOtp({ username: this.username, otp_code: this.otpCode }).then(() => {
				this.redirect()
			});
		},
		onPin() {
			this.loginPin({ username: this.username, pin_code: this.pinCode }).then(() => {
				this.redirect()
			});
		},
		redirect() {
			const { redirect } = this.$route.query;

			if (redirect) {
				this.$router.push('/');
			} else {
				this.$router.push({ name: 'transaction' });
			}
		},
		userClick() {
			this.user = true
		},
		userBlur() {
			if( this.username != "" ) {
				this.user = true
			} else {
				this.user = false
			}
		},
		passClick() {
			this.pass = true
		},
		passBlur() {
			if( this.password != "" ) {
				this.pass = true
			} else {
				this.pass = false
			}
		},
		showPassword() {
			var x = document.getElementById("in-password");
			if (x.type === "password") {
				x.type = "text"
				this.sPassword = false
			} else {
				x.type = "password"
				this.sPassword = true
			}
		},
	},
	created() {
		this.$store.dispatch('setPageTitle', 'Login');
	},
	mounted() {
		this.userClick()
		this.passClick()
	},
	beforeDestroy() {
		this.reset();
	},
};
</script>
